import React from "react";
import { Link } from "react-router-dom";

interface CrumbItem {
  to: string;
  label: string;
}

interface BreadcrumbProps {
  parents: CrumbItem[];
  current: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ parents, current }) => (
  <div className="breadcrumb-bar">
    <div className="swiss-grid">
      <div className="col-span-12">
        <div className="crumb">
          {parents.map((c, i) => (
            <React.Fragment key={c.to}>
              {i > 0 && <span className="sep">{"›"}</span>}
              <Link to={c.to}>{c.label}</Link>
            </React.Fragment>
          ))}
          <span className="sep">{"›"}</span>
          <b>{current}</b>
        </div>
      </div>
    </div>
  </div>
);

export default Breadcrumb;
